export default function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/utils/canUseDom.js
// module id = 7523
// module chunks = 2